const BASE_URL = 'https://app.rakeshbansalventures.com/api/baseV1';
//  const BASE_URL = 'https://learnrkb.in:9030/api/baseV1';
// const BASE_URL = 'http://20.197.43.210:9030/api/baseV1';
//const BASE_URL = 'http://49.205.177.39:9092/api/baseV1';
// const BASE_URL = 'https://49.205.177.39:9097/api/baseV1';
// const BASE_URL =     'http://localhost:9092/api/baseV1';
// const BASE_URL = 'http://localhost:9097/api/baseV1';

// const Python_BASE_URL = 'https://rkbforu.com:8084/api/baseV1'
const Python_BASE_URL = 'http://20.197.43.210:8909/api/baseV1'
// const Python_BASE_URL = 'http://49.205.177.39:9098/api/baseV1'
// const Python_BASE_URL = 'http://localhost:9098/api/baseV1'




const Telegram_BASE_URL = 'http://20.197.43.210:8000'
// const Telegram_BASE_URL = 'http://20.197.54.137:9031/'
// const Telegram_BASE_URL = 'http://localhost:8000'


//  ******prod its for telegram *****
//  const CHAT_IDS = {
//   Future: '-1001631194193',
//   Options: '-1001747080302',
//   Delivery: '-1001674828252',
//   HNI: '-1002063080484',
//   Commodity: '-1002138033725',
//   IntraDay: '-1002163231873',
//   Free:'-1001278461377'
//  };

// const CHAT_IDS = {
//     Renko: '-1002253060338',
//     Future: '-1002253060338',
//     Options: '-1002253060338',
//     Delivery: '-1002253060338',
//     HNI: '-1002253060338',
//     Commodity: '-1002253060338',
//     IntraDay: '-1002253060338',
//     Free:'-1002253060338',
// };

const CHAT_IDS = {
    Renko: '-1002153000538',
    Future: '-1002153000538',
    Options: '-1002153000538',
    Delivery: '-1002153000538',
    HNI: '-1002153000538',
    Commodity: '-1002153000538',
    IntraDay: '-1002153000538',
    Free:'-1002153000538',
};
  
  //  ***** prod chat ids ********
  
  //  const Rigi_CHAT_IDS = {
  //   Future:'65bba8d6c908731d0d764df2',
  //   Options:'65bba85ec908731d0d764b39',
  //   Delivery:'65bba7d25225ea1d1993eceb',
  //   HNI:'660e89a9e1bc5f0b7cba224e',
  //   Commodity:'660e86bff11a5c0b7691312f',
  //   IntraDay:'6658d377a38d020bf604a544',
  //   Free:'660e51bf405b490b71daec88'
  //  }
   
//    const Rigi_CHAT_IDS = {
//     Future:'660e51bf405b490b71daec88',
//     Options:'660e51bf405b490b71daec88',
//     Delivery:'660e51bf405b490b71daec88',
//     HNI:'660e51bf405b490b71daec88',
//     Commodity:'660e51bf405b490b71daec88',
//     IntraDay:'660e51bf405b490b71daec88',
//     Free:'660e51bf405b490b71daec88'
//    }


// Export variables
module.exports = {
    BASE_URL, 
    Python_BASE_URL,
    CHAT_IDS,
    Telegram_BASE_URL
    // Rigi_CHAT_IDS  
};
